// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3lyyY","inputWrap":"CustomTip_inputWrap__2HKLw"};